import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  action?: ReactNode;
}

export default function EmptyState({
  icon = "ri-file-search-line",
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-700">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}